import { formatDateToLocalFormat } from "../../../../../../features/dataFunctions/format/date";
import { useMapDispatch } from "../../../../../../stateManagement/hooks/useMapDispatch";
import { MapName } from "../../../../../../stateManagement/reducers/maps/actions";
import { store } from "../../../../../../stateManagement/store";

type CalendarValues = {
    minValue?: string,
    maxValue?: string,
    value?: string,
}

export function configureCalendarValues(operation: string): CalendarValues {
    let minValue, maxValue, value;
    const currentDate = new Date().toString()
    if (operation === "between") {
        minValue = null
        maxValue = null
    } else {
        value = currentDate;
    }
    return {
        ...(value ? { value } : {}),
        ...(minValue ? { minValue } : {}),
        ...(maxValue ? { maxValue } : {})
    }
}

export function configureCalendarHintText(option: string | undefined) {
    let text = "Выберите";
    if (option === "year") return text + " начальный год";
    if (option === "month") return text + " начальный месяц";
    return text + " начальную дату";
}

export function patchFilterCalendarState(
    mapName: MapName,
    fieldName: string,
    patch: any,
    dispatchMap: ReturnType<typeof useMapDispatch>,
) {
    const lowerFirstMapName = mapName[0].toLowerCase() + mapName.slice(1) as MapName
    const currentFilterState = store.getState().maps[lowerFirstMapName].mapFiltersState[fieldName];
    let patchForSend: any = {}
    if (!currentFilterState) return;

    // строится patchForSend */
    let { isIgnored, includeNull, minValue, maxValue, value } = patch ?? {}
    if ('isIgnored' in patch) patchForSend = { isIgnored }
    if ('includeNull' in patch) patchForSend = { isIgnored: false, includeNull }
    if ('minValue' in patch && 'maxValue' in patch) {
        let hintText
        if (minValue) {
            minValue = minValue.toString()
            hintText = "Выберите конечную дату"
        }
        if (maxValue) {
            maxValue = maxValue.toString()
            hintText = `${formatDateToLocalFormat(minValue)}-${formatDateToLocalFormat(maxValue)}`
        }
        patchForSend = {
            minValue,
            maxValue,
            hintText,
            ...(maxValue ? { isIgnored: false } : {})
        }
    }
    if ('value' in patch) {
        patchForSend = { value: value.toString() }
    }

    dispatchMap(mapName, 'patchMapFiltersState', { fieldName, patch: patchForSend });
}

export function configureCalendarFormattedValue(minValue: string, maxValue: string, value: string): Date | [Date, Date] | [Date, null] | undefined {
    if (minValue) {
        let formattedMinValue = new Date(minValue)
        let formattedMaxValue = maxValue ? new Date(maxValue) : null
        return [formattedMinValue, formattedMaxValue]
    } else if (value) {
        return new Date(value)
    } else return undefined
}